import { normalizarTexto } from '../lib/textoBR'

// SO o que e inequivoco em portugues. Duzia e 12 e meia duzia e 6 em qualquer
// fabrica; caixa, fardo, saco e balde dependem do produto -- e sistema que chuta
// numero de embalagem faz o vendedor mandar pedido errado para a fabrica.
//
// Decisao dela em 28/08: sugerir o obvio, NUNCA gravar sozinho. Quem grava e a
// pessoa, confirmando na ficha.
//
// ⚠⚠ A METADE E PROCURADA NA STRING CRUA, ANTES DE NORMALIZAR, e isso nao e
// preciosismo: `normalizarTexto` tem um `.replace(/[^a-z0-9\s]/g, ' ')` que
// APAGA o `½`, e por isso `normalizarTexto('½ dz')` devolve exatamente `'dz'`
// (medido em 28/08). Normalizar primeiro faria MEIA DUZIA SUGERIR 12 -- em 18
// produtos reais do banco dela (Forte Pan 9, Metasa 9), e sem erro na tela.
const MARCAS_DE_METADE = ['½', '1/2', 'meia']

export function sugerirFator(unidade: string | null | undefined): number | null {
  if (!unidade) return null
  const cru = unidade.trim().toLowerCase()
  const ehMetade = MARCAS_DE_METADE.some((marca) => cru.includes(marca))
  // Depois da metade decidida, a normalizacao serve para o resto: tira acento,
  // caixa alta e o ponto de "dz.".
  const chave = normalizarTexto(cru)
  const ehDuzia = chave.includes('dz') || chave.includes('duzia')
  if (!ehDuzia) return null
  return ehMetade ? 6 : 12
}
